import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

export const getAllFinancialYears = async () => {
    try {
        const response = await axios.get(`${base}/Accounts/GetAllFinancialYears`);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch financial years';
    }
};

/** CCType: 'Active CCs' | 'Closed CCs' */
export const getProjectFinancialStatusSummaryReportGrid = async ({ CCType, Fyear }) => {
    try {
        const response = await axios.get(`${base}/Reports/ProjectFinancilaStatusSummaryReportGrid`, { params: { CCType, Fyear } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch project financial status summary';
    }
};
